import { gql } from '@apollo/client';

//Update this!
export const GET_CORE_SERVER_URL = gql`
  query GET_CORE_SERVER_URL($originatorId: ID!){
    getCoreServerUrl(originatorId: $originatorId) {
     url
     args
  }
}
`;